import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../actions";

const initialState = {
  page: 0,
  data: {
    orderNumber: "",
    orderDate: "",
    orderForm: 34,
    orderStatus: 1,
    serviceOption: 0,
    sampleAmount: "",
    otherComments: "",
    dropBoxId: null,
    dropBoxDate: "",
    tableData: [],
	orderAmount: 0,
	discountId: null
  },
  billingInformation: {
    firstName: "",
    lastName: "",
    company: "",
    phone: "",
    email: "",
    shippingOption: "Dropbox",
    dropboxLocation: "",
    dropoffDate: "",
    billingMethod: "",
    purchasingAgentName: "",
    purchasingAgentEmail: "",
    poNumber: "",
    grantNumber:"",
    grantPi:"",
    grantNote:"",
    ccNumber: "",
    ccMonth: "",
    ccYear: "",
    cvv: "",
	ccZip: "",
    cardType: "",
    ccName: "",
    acgtCard: "",
  },
  primer: {
    primerList: [],
    primerAmount: 0,
    banking: 0,
    comments: "",
    primerSynthesisList: [],
    synthesis: 0,
  },
};

const dcssFormSlice = createSlice({
  name: "dcssorderform",
  initialState,
  reducers: {
    //action creators
    initializeDcssTableData(state, action) {
      for (let i = 0; i < action.payload; i++) {
        const newObj = {
          id: i + 1,
          dName: "",
          dFormat: "",
          dType: "",
          library: "",
          pName: "",
          pConc: 0,
          pbp: false,
          alt: "",
          orderId: 0,
        };
        state.data.tableData.push(newObj);
      }
      return;
    },
    resetDcssState(state, action) {
      Object.assign(state, initialState);
      return;
    },
    resetDcssTableData(state, action) {
      state.data.tableData = action.payload;
      return;
    },
    setDcssSampleAmount(state, action) {
      state.data.sampleAmount = parseInt(action.payload);
      return;
    },
    addDcssRow(state, action) {
      const newRow = action.payload;
      // Add the new row to the end of tableData
      state.data.tableData.push(newRow);

      // Reset the indices in the updated tableData
      state.data.tableData = state.data.tableData.map((item, index) => ({
        ...item,
        id: index + 1,
      }));
      state.data.sampleAmount = parseInt(state.data.sampleAmount + 1);
      return;
    },
    editDcssRow(state, action) {
      const { index, value, property } = action.payload;
      let pattern = /^[a-zA-Z0-9-_]{0,20}$/;
      const updatedData = [...state.data.tableData];

      if (property === "dName" || property === "pName") {
        if (pattern.test(value)) {
          updatedData[index][property] = value;
        } else {
          // You may want to handle this case differently, e.g., show an error message
          alert(
            "Only special characters allowed: hyphen( - ) and underscore( _ )."
          );
          return;
        }
      } else {
        updatedData[index][property] = value;
      }

      // Assuming your state has a property named "tableData"
      state.data.tableData = updatedData;
    },
    copyDcssRow(state, action) {
      const { index } = action.payload;
      const rowToCopy = state.data.tableData[index];

      // Create a copy of the row with a new id
      const copiedRow = {
        ...rowToCopy,
        id: state.data.tableData.length + 1, // Assign a new id or adjust as needed
      };

      // Insert the copied row at a specific position (e.g., next to the original row)
      state.data.tableData.splice(index + 1, 0, copiedRow);

      // Reset the indices in the updated tableData
      state.data.tableData = state.data.tableData.map((item, i) => ({
        ...item,
        id: i + 1,
      }));
      state.data.sampleAmount = parseInt(state.data.sampleAmount + 1);
      return;
    },
    deleteDcssRow(state, action) {
      const { index } = action.payload;
      const updatedTableData = state.data.tableData.filter(
        (item, i) => i !== index
      );

      // Reset the indices in the updated tableData
      const resetIndexedTableData = updatedTableData.map((item, i) => ({
        ...item,
        id: i + 1,
      }));

      // Update the tableData state
      state.data.tableData = resetIndexedTableData;
      state.data.sampleAmount = parseInt(state.data.sampleAmount - 1);
      return;
    },
    toggleDcssCheckbox(state, action) {
      const { index, property } = action.payload;
      const newData = [...state.data.tableData];
      newData[index][property] = !newData[index][property];
      state.data.tableData = newData;
    },
    increaseDcssConcentration(state, action) {
      const { index, property } = action.payload;
      state.data.tableData[index][property] += 1;
    },
    decreaseDcssConcentration(state, action) {
      const { index, property } = action.payload;
      if (state.data.tableData[index][property] > 0) {
        state.data.tableData[index][property] -= 1;
      }
    },
    clearDcssSelect(state, action) {
      const { index, property } = action.payload;

      state.data.tableData[index] = {
        ...state.data.tableData[index],
        [property]: "", // Set the specified property to an empty string for the specific row
      };

      return;
    },
    dcssPrevStep: (state, action) => {
      state.page = state.page - 1;
    },
    dcssNextStep: (state, action) => {
      state.page = state.page + 1;
    },
    dcssSetStep: (state, action) => {
      state.page = action.payload;
    },
    resetDcssPage: (state, action) => {
      state.page = action.payload;
    },
    initializeDcssPrimerTableData(state, action) {
      for (let i = 0; i < action.payload; i++) {
        const newObj = {
          id: i + 1,
          pName: "",
          pSequence: "",
        };
        state.primer.primerSynthesisList.push(newObj);
      }
      return;
    },
    resetDcssPrimerTableData(state, action) {
      state.primer.primerSynthesisList = action.payload;
    },
    setDcssPrimerAmount(state, action) {
      state.primer.primerAmount = parseInt(action.payload);
      return;
    },
    addDcssPrimerRow: (state, action) => {
      const newRow = action.payload;
      // Add the new row to the end of tableData
      state.primer.primerSynthesisList.push(newRow);

      // Reset the indices in the updated tableData
      state.primer.primerSynthesisList = state.primer.primerSynthesisList.map(
        (item, index) => ({
          ...item,
          id: index + 1,
        })
      );
      state.primer.primerAmount = parseInt(state.primer.primerAmount + 1);
      return;
    },
    editDcssPrimerRow(state, action) {
      const { index, property, value } = action.payload;
      let pattern = /^[a-zA-Z0-9_-]*$/;
      const updatedData = [...state.primer.primerSynthesisList];

		if (property === "pName") {
			if (pattern.test(value)) {
				updatedData[index][property] = value;
			} else {
			// You may want to handle this case differently, e.g., show an error message
			return;
			}
		} else if (property === "pSequence") {
			let pattern2 = /^[acgtACGT]*$/
			if (pattern2.test(value)) {
				updatedData[index][property] = value;
			} else {
			alert(
				"Primers with degenerate bases cannot be used for Sanger sequencing. Primer sequence must match the template it binds to exactly."
				// "Only characters allowed: A, C, G and T"
			);
				return;
			}
		} else {
        updatedData[index][property] = value;
      }

      // Assuming your state has a property named "tableData"
      state.primer.primerSynthesisList = updatedData;
    },
    deleteAllDcssPrimer(state, action) {
      state.primer.primerSynthesisList = action.payload;
      state.primer.primerAmount = "";
      return;
    },
    setDcssPrimerBanking(state, action) {
      state.primer.banking = action.payload;
      return;
    },
    setDcssPrimerList(state, action) {
      const list = action.payload.split(/,\s|\n|,/);
      state.primer.primerList = list;
      // console.log(state.primer.primerList);
      return;
    },
    setDcssPrimerSynthesis(state, action) {
      state.primer.synthesis = action.payload;
      return;
    },
    setDcssPrimerComments(state, action) {
      state.primer.comments = action.payload;
      return;
    },
    setDcssDropboxLocation(state, action) {
      state.billingInformation.dropboxLocation = action.payload.label;
      return;
    },
    setDcssDropboxId(state, action) {
      state.data.dropBoxId = action.payload;
      return;
    },
    setDcssDropoffDate(state, action) {
      state.billingInformation.dropoffDate = action.payload;
      state.data.dropBoxDate = action.payload;
      // Test the regular expression with a date
      // if (dateRegex.test(result)) {
      // }
    },
    setDcssFirstName(state, action) {
      state.billingInformation.firstName = action.payload;
      return;
    },
    setDcssLastName(state, action) {
      state.billingInformation.lastName = action.payload;
      return;
    },
    setDcssCompany(state, action) {
      state.billingInformation.company = action.payload;
    },
    setDcssPhone(state, action) {
      const phoneRegex = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
      const result = action.payload;

      // Test the regular expression with a date
      // if (phoneRegex.test(result)) {
      //   state.billingInformation.phone = result;
      // }
      state.billingInformation.phone = result;
    },
    setDcssEmail(state, action) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      state.billingInformation.email = action.payload;
    },
    setDcssShippingOption(state, action) {
      state.billingInformation.shippingOption = action.payload;
      return;
    },
    setDcssAcgtCard(state, action) {
      state.billingInformation.acgtCard = action.payload;
      return;
    },
    setDcssCCNumber(state, action) {
      state.billingInformation.ccNumber = action.payload;
      return;
    },
    setDcssCCMonth(state, action) {
      state.billingInformation.ccMonth = action.payload;
      return;
    },
    setDcssCCYear(state, action) {
      state.billingInformation.ccYear = action.payload;
      return;
    },
    setDcssCVV(state, action) {
      state.billingInformation.cvv = action.payload;
      return;
    },
	setDcssCCZip(state, action) {
      state.billingInformation.ccZip = action.payload;
      return;
    },
    setDcssCCName(state, action) {
      state.billingInformation.ccName = action.payload;
      return;
    },
    setDcssCardType(state, action) {
      state.billingInformation.cardType = action.payload;
      return;
    },
    setDcssBillingMethod(state, action) {
      state.billingInformation.billingMethod = action.payload;
      return;
    },
    setDcssPurchasingAgentName(state, action) {
      state.billingInformation.purchasingAgentName = action.payload;
      return;
    },
    setDcssPurchasingAgentEmail(state, action) {
      state.billingInformation.purchasingAgentEmail = action.payload;
      return;
    },
    setDcssPoNumber(state, action) {
      state.billingInformation.poNumber = action.payload;
      return;
    },
    setDcssGrantNumber(state, action) {
      state.billingInformation.grantNumber = action.payload;
      return;
    },
    setDcssGrantPI(state, action) {
      state.billingInformation.grantPi = action.payload;
      return;
    },
    setDcssGrantNote(state, action) {
      state.billingInformation.grantNote = action.payload;
      return;
    },
    setDcssOrderNumber(state, action) {
      state.data.orderNumber = action.payload
      return;
    },
    setDcssOrderAmount(state, action) {
      state.data.orderAmount = action.payload
      return;
	},
	setDcssOrderDiscount(state, action) {
		state.data.discountId = action.payload
	},
  },
  //tell our combined reducer to look for additional action types
  extraReducers(builder) {
    builder.addCase(reset, (state, action) => {
      return {};
    });
  },
});

export const {
  initializeDcssTableData,
  resetDcssState,
  resetDcssTableData,
  setDcssSampleAmount,
  addDcssRow,
  editDcssRow,
  copyDcssRow,
  deleteDcssRow,
  toggleDcssCheckbox,
  increaseDcssConcentration,
  decreaseDcssConcentration,
  clearDcssSelect,
  dcssNextStep,
  dcssPrevStep,
  dcssSetStep,
  resetDcssPage,
  initializeDcssPrimerTableData,
  resetDcssPrimerTableData,
  setDcssPrimerAmount,
  addDcssPrimerRow,
  editDcssPrimerRow,
  deleteAllDcssPrimer,
  setDcssPrimerBanking,
  setDcssPrimerList,
  setDcssPrimerSynthesis,
  setDcssPrimerComments,
  setDcssDropoffDate,
  setDcssDropboxLocation,
  setDcssDropboxId,
  setDcssFirstName,
  setDcssLastName,
  setDcssCompany,
  setDcssPhone,
  setDcssEmail,
  setDcssShippingOption,
  setDcssAcgtCard,
  setDcssCCNumber,
  setDcssCCMonth,
  setDcssCCYear,
  setDcssCVV,
  setDcssCCZip,
  setDcssCCName,
  setDcssCardType,
  setDcssPurchasingAgentName,
  setDcssPurchasingAgentEmail,
  setDcssPoNumber,
  setDcssGrantNumber,
  setDcssGrantPI,
  setDcssGrantNote,
  setDcssOrderNumber,
	setDcssOrderAmount,
	setDcssOrderDiscount,
  setDcssBillingMethod,
} = dcssFormSlice.actions;
export const dcssFormReducer = dcssFormSlice.reducer;
